// TOP LEVEL IMPORTS
import gql from "graphql-tag";

export default gql`
  mutation getPresignedUploadUrl($contentType: String!) {
    getPresignedUploadUrl(contentType: $contentType) {
      url
      fields
    }
  }
`;
